import { combineReducers } from 'redux';
import activate from './activateUserReducer';
import info from './getMeInfoReducer';
import users from './getUsersReducer';
import edit from './editUserReducer';
import reset from './resetUserPasswordReducer';
import undelete from './undeleteUserReducer';
import update from './updateUserReducer';
import payee from './payeeUserReducer';
import admin from './adminUserReducer';
import admins from './getAdminsReducer';

export default combineReducers({
    activate,
    edit,
    info,
    list: users,
    reset,
    undelete,
    update,
    payee,
    admins,
    admin
});



// WEBPACK FOOTER //
// ./src/reducers/userReducer/index.js